<header #header class="fixed z-[120] inset-x-0 top-0 bg-white h-[75px] shadow shadow-gray-100">
  <div class="container h-full flex items-center justify-between">
    <a [routerLink]="['/home']" class="flex max-w-[125px] lg:max-w-[130px]">
      <img ngSrc="/images/braidsbook-logo.png" width="288" height="54" alt="{{ 'FOOTER.LOGO_ALT' | translate }}"
        class="w-full h-full" priority>
    </a>

    <nav class="hidden lg:flex items-center gap-7 text-gray-700">
      @if (isHydrated() && currentUser()?.user_type !== 'hairdresser' && currentUser()?.user_type !== 'salon_owner') {
      <a [routerLink]="['/home']" [routerLinkActive]="['text-primary']"
        class="cursor-pointer text-sm hover:text-primary transition">{{ 'HEADER.HOME' | translate }}</a>
      <!--
        « Coiffeurs » mène au choix de la ville, pas directement au listing :
        une cliente cherche d'abord près de chez elle. Le listing complet reste
        accessible depuis le hub.
      -->
      <a [routerLink]="['/hairdressers', 'city']" [routerLinkActive]="['text-primary']"
        class="cursor-pointer text-sm hover:text-primary transition">{{ 'HEADER.HAIRDRESSERS' | translate }}</a>
      <a [routerLink]="['/boutique']" [routerLinkActive]="['text-primary']"
        class="cursor-pointer text-sm hover:text-primary transition">{{ 'HEADER.SHOP' | translate }}</a>
      }

      @if (isAuthenticated() && currentUser()?.user_type === 'hairdresser') {
      <a [routerLink]="['/hairdresser/salon']" [routerLinkActive]="['text-main-500']"
        class="cursor-pointer text-sm hover:text-primary transition">{{ 'HEADER.DASHBOARD' | translate }}</a>
      <a [routerLink]="['/profile/hairdresser/products']" [routerLinkActive]="['text-main-500']"
        class="cursor-pointer text-sm hover:text-primary transition">{{ 'HEADER.MY_PRODUCTS' | translate }}</a>
      <a [routerLink]="['/hairdresser/subscription']" [routerLinkActive]="['text-main-500']"
        class="cursor-pointer text-sm hover:text-primary transition">Abonnement</a>
      }

      @if (isAuthenticated() && currentUser()?.user_type === 'salon_owner') {
      <a [routerLink]="['/salon/dashboard']" [routerLinkActive]="['text-main-500']"
        class="cursor-pointer text-sm hover:text-primary transition">{{ 'HEADER.DASHBOARD' | translate }}</a>
      <a [routerLink]="['/salon/team']" [routerLinkActive]="['text-main-500']"
        class="cursor-pointer text-sm hover:text-primary transition">Équipe</a>
      <a [routerLink]="['/salon/reservations']" [routerLinkActive]="['text-main-500']"
        class="cursor-pointer text-sm hover:text-primary transition">Réservations</a>
      }
    </nav>

    <div class="flex items-center gap-2.5 lg:gap-4">
      <braidsbook-language-switcher class="flex" />

      @if (isHydrated() && currentUser()?.user_type !== 'hairdresser' && currentUser()?.user_type !== 'salon_owner') {
      <button type="button" (click)="openCart()" [attr.aria-label]="'HEADER.CART' | translate"
        class="relative size-9 rounded-full flex items-center justify-center text-gray-700 hover:text-primary hover:bg-gray-50 transition">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" /><path d="M3 6h18" /><path d="M16 10a4 4 0 0 1-8 0" />
        </svg>
        @if (cartCount() > 0) {
        <span class="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-white text-[10px] font-semibold flex items-center justify-center">
          {{ cartCount() > 99 ? '99+' : cartCount() }}
        </span>
        }
      </button>
      }

      @if (!isAuthenticated()) {
      <!-- Auth Buttons (Desktop only) -->
      <div class="hidden lg:flex items-center gap-2.5">
        <a [routerLink]="['/auth/login']"
          class="cursor-pointer border border-primary text-primary rounded-full text-sm py-3 px-6 w-32 text-center hover:bg-main-50/20 transition">
          {{ 'HEADER.LOGIN' | translate }}
        </a>
        <a [routerLink]="['/auth/status']"
          class="cursor-pointer border bg-primary text-white rounded-full text-sm py-3 px-6 w-32 text-center hover:bg-main-600 transition">
          {{ 'HEADER.REGISTER' | translate }}
        </a>
      </div>
      } @else {
      <!-- User Section (Desktop & Mobile) -->
      <div class="flex items-center gap-3">
        <!-- Notifications (Hairdressers only) -->
        @if (currentUser()?.user_type === 'hairdresser') {
        <braidsbook-notifications></braidsbook-notifications>
        }

        <!-- User Avatar & Dropdown -->
        <button [cdkMenuTriggerFor]="menu"
          [cdkMenuPosition]="[{originX:'end', originY:'bottom', overlayX:'end', overlayY:'top'}]"
          class="size-8 lg:size-9 overflow-hidden relative rounded-full border-2 border-main-500">
          <img [ngSrc]="currentUser()?.pp_link || '/images/avatar.png'" [alt]="currentUser()?.firstname"
            class="object-cover bg-primary-light" fill>
        </button>
      </div>

      <!-- User Menu Dropdown -->
      <ng-template #menu>
        <ul cdkMenu class="p-2 translate-y-1 rounded-lg border text-sm bg-white border-gray-200 shadow-xl">
          <li cdkMenuItem class="flex py-3 rounded-md px-4 flex-col items-center justify-center bg-gray-50 mb-2">
            <div class="size-14 rounded-full relative overflow-hidden mb-1.5 border-2 border-main-500">
              <img [ngSrc]="currentUser()?.pp_link || '/images/avatar.png'" [alt]="currentUser()?.firstname"
                class="object-cover bg-primary-light" fill>
            </div>
            <div class="font-semibold text-gray-900">{{ currentUser()?.firstname }} {{ currentUser()?.lastname }}
            </div>
            <div class="text-xs text-gray-500">{{ currentUser()?.email }}</div>
          </li>

          <li class="flex gap-1">
            @if (currentUser()?.user_type === 'client') {
            <a [routerLink]="['/profile/customer']" cdkMenuItem
              class="py-2 px-3.5 w-full rounded-md hover:bg-gray-100 duration-200 flex items-center justify-start gap-2.5">
              <icon-user-round-cog [size]="18" />
              <span>{{ 'HEADER.PROFILE' | translate }}</span>
            </a>
            <a [routerLink]="['/profile/customer/orders']" cdkMenuItem
              class="py-2 px-3.5 w-full rounded-md hover:bg-gray-100 duration-200 flex items-center justify-start gap-2.5">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" /><path d="M3 6h18" /><path d="M16 10a4 4 0 0 1-8 0" />
              </svg>
              <span>{{ 'HEADER.MY_ORDERS' | translate }}</span>
            </a>
            }
            @if (currentUser()?.user_type === 'hairdresser') {
            <a [routerLink]="['/profile/hairdresser/edit']" cdkMenuItem
              class="py-2 px-3.5 w-full rounded-md hover:bg-gray-100 duration-200 flex items-center justify-start gap-2.5">
              <icon-user-round-cog [size]="18" />
              <span>{{ 'HEADER.PROFILE' | translate }}</span>
            </a>
            }
            @if (currentUser()?.user_type === 'salon_owner') {
            <a [routerLink]="['/salon/dashboard']" cdkMenuItem
              class="py-2 px-3.5 w-full rounded-md hover:bg-gray-100 duration-200 flex items-center justify-start gap-2.5">
              <icon-user-round-cog [size]="18" />
              <span>Mon salon</span>
            </a>
            }

            <button (click)="logout()" cdkMenuItem
              class="py-2 px-3.5 w-full text-red-500 rounded-md hover:bg-red-50 duration-200 flex items-center justify-start gap-2.5 border-t border-gray-100 mt-1">
              <icon-logout [size]="18" />
              <span>{{ 'HEADER.LOGOUT' | translate }}</span>
            </button>
          </li>
        </ul>
      </ng-template>
      }
      <!-- Mobile Menu Toggle -->
      <button (click)="toggleMenu()" class="border border-gray-100 rounded-sm p-1 lg:hidden ml-2">
        @if (!isMenuToggled) {
        <icon-burger [size]="20" />
        } @else {
        <icon-close [size]="20" />
        }
      </button>
    </div>
  </div>
</header>

@if (isMenuToggled) {
<div class="fixed inset-x-0 z-[100] bg-white items-center"
  [ngStyle]="{'top' : header.offsetHeight + 'px', 'height': 'calc(100dvh - ' + header.offsetHeight + 'px)'}">


  <!-- Contenu principal scrollable -->
  <div class="flex-1 flex flex-col gap-3.5 justify-center items-center font-medium text-[15px]">

    <!-- Section Navigation -->
    <div class="px-6 py-6 border-b border-gray-100">
      <nav class="flex flex-col gap-3">
        @if (isHydrated() && currentUser()?.user_type !== 'hairdresser' && currentUser()?.user_type !== 'salon_owner') {
        <a [routerLink]="['/home']" [routerLinkActive]="['text-main-500']" (click)="onNavigate()"
          class="text-center text-gray-700">
          <span class="font-medium">{{ 'HEADER.HOME' | translate }}</span>
        </a>
        <a [routerLink]="['/hairdressers', 'city']" [routerLinkActive]="['text-main-500']" (click)="onNavigate()"
          class="text-center text-gray-700">
          <span class="font-medium">{{ 'HEADER.HAIRDRESSERS' | translate }}</span>
        </a>
        <a [routerLink]="['/boutique']" [routerLinkActive]="['text-main-500']" (click)="onNavigate()"
          class="text-center text-gray-700">
          <span class="font-medium">{{ 'HEADER.SHOP' | translate }}</span>
        </a>
        }

        @if (isAuthenticated() && currentUser()?.user_type === 'hairdresser') {
        <a [routerLink]="['/hairdresser/salon']" [routerLinkActive]="['text-main-500', 'bg-main-50']"
          (click)="onNavigate()" class="rounded-lg text-gray-700">
          <span class="font-medium">{{ 'HEADER.DASHBOARD' | translate }}</span>
        </a>
        <a [routerLink]="['/profile/hairdresser/services']" [routerLinkActive]="['text-main-500', 'bg-main-50']"
          (click)="onNavigate()" class="rounded-lg text-gray-700">
          <span class="font-medium">{{ 'HEADER.MY_SERVICES' | translate }}</span>
        </a>
        <a [routerLink]="['/profile/hairdresser/gallery']" [routerLinkActive]="['text-main-500', 'bg-main-50']"
          (click)="onNavigate()" class="text-gray-700">
          <span class="font-medium">{{ 'HEADER.GALLERY' | translate }}</span>
        </a>
        <a [routerLink]="['/profile/hairdresser/products']" [routerLinkActive]="['text-main-500', 'bg-main-50']"
          (click)="onNavigate()" class="text-gray-700">
          <span class="font-medium">{{ 'HEADER.MY_PRODUCTS' | translate }}</span>
        </a>
        <a [routerLink]="['/hairdresser/subscription']" [routerLinkActive]="['text-main-500', 'bg-main-50']"
          (click)="onNavigate()" class="text-gray-700">
          <span class="font-medium">Abonnement</span>
        </a>
        }

        @if (isAuthenticated() && currentUser()?.user_type === 'salon_owner') {
        <a [routerLink]="['/salon/dashboard']" [routerLinkActive]="['text-main-500', 'bg-main-50']"
          (click)="onNavigate()" class="rounded-lg text-gray-700">
          <span class="font-medium">{{ 'HEADER.DASHBOARD' | translate }}</span>
        </a>
        <a [routerLink]="['/salon/team']" [routerLinkActive]="['text-main-500', 'bg-main-50']"
          (click)="onNavigate()" class="rounded-lg text-gray-700">
          <span class="font-medium">Équipe</span>
        </a>
        <a [routerLink]="['/salon/reservations']" [routerLinkActive]="['text-main-500', 'bg-main-50']"
          (click)="onNavigate()" class="text-gray-700">
          <span class="font-medium">Réservations</span>
        </a>
        }
      </nav>
    </div>

    <!-- Section Contact -->
    <div class="px-6 py-6 border-b border-gray-100">

      <div class="flex flex-col gap-3 text-center">
        <div class="text-sm text-gray-600">
          <span>Québec, Canada</span>
        </div>

        <div class="text-sm text-gray-600">
          <a href="tel:+33123456789" class="hover:text-main-500 transition-colors">
            +1 (438) 939-4090
          </a>
        </div>

        <div class="text-sm text-gray-600">
          <a href="mailto:info@braidsbook.com" class="hover:text-main-500 transition-colors">
            info&#64;braidsbook.com
          </a>
        </div>
      </div>
    </div>

    <!-- Section Réseaux sociaux -->
    <div class="px-6 py-6">

      <div class="flex items-center gap-3">
        <a href="#" target="_blank"
          class="w-10 h-10 bg-main-600 rounded-full flex items-center justify-center text-white">
          <icon-facebook [size]="18" />
        </a>
        <a href="#" target="_blank"
          class="w-10 h-10 bg-main-600 rounded-full flex items-center justify-center text-white">
          <icon-instagram [size]="18" />
        </a>
        <a href="#" target="_blank"
          class="w-10 h-10 bg-main-600 rounded-full flex items-center justify-center text-white">
          <icon-twitter [size]="18" />
        </a>
      </div>
    </div>
  </div>

  <!-- Footer avec actions d'authentification (si non connecté) -->
  @if (!isAuthenticated()) {
  <div class="border-t border-gray-200 p-6">
    <div class="grid grid-cols-2 gap-3">
      <a [routerLink]="['/auth/login']"
        class="border border-main-500 text-main-500 rounded-full text-sm py-3 text-center">
        {{ 'HEADER.LOGIN' | translate }}
      </a>
      <a [routerLink]="['/auth/status']" class="bg-main-500 text-white rounded-full text-sm py-3 text-center">
        {{ 'HEADER.REGISTER' | translate }}
      </a>
    </div>

    <!-- Version app -->
    <div class="text-center mt-4">
      <span class="text-xs text-gray-400">Version 1.0.0</span>
    </div>
  </div>
  }
</div>
}